import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { SelectInput } from "@/lib/Components/Form/Inputs/SelectInput";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updatePromotionChannelMutation } from "@/app/Promotions/GraphQL/promotionChannelMutations";
import { Currency, PromotionStatus } from "@/gql/graphql";
import { toast } from "sonner";
import { useTranslations } from "use-intl";

export function EditPromotionChannelDialog({
  channelId,
  budgetAmount,
  status,
}: {
  channelId: string;
  budgetAmount: number;
  status: PromotionStatus;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(updatePromotionChannelMutation);
  const t = useTranslations("promotion.editDialog");

  return (
    <BaseDialog title={t("title")}>
      <GenericForm
        initialValues={{
          budget: budgetAmount,
          status,
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: channelId,
            input: {
              budget_amount: values.budget,
              status: values.status,
            },
          });

          toast.success(t("success"));

          await close();
        }}
      >
        <CurrencyInput
          className="col-span-full"
          name="budget"
          label={t("budgetLabel")}
          currency={Currency.Usd}
        />

        <SelectInput
          className="col-span-full"
          name="status"
          label={t("statusLabel")}
          options={[
            {
              label: "",
              options: [
                { value: PromotionStatus.Active, label: t("statusActive") },
                { value: PromotionStatus.Paused, label: t("statusPaused") },
                {
                  value: PromotionStatus.Archived,
                  label: t("statusArchived"),
                },
              ],
            },
          ]}
        />

        <DialogSubmitButton text={t("submit")} />
      </GenericForm>
    </BaseDialog>
  );
}
